module.exports = __webpack_public_path__ + "static/media/index-mob-2.dc86975a.png";